export default __webpack_public_path__ + "static/media/Connecticut6.a75b796f.png";